<template>
  <div>
    <v-card
      class="progress-container"
      v-if="initialLoading">
      <v-progress-circular
      :size="120"
      color="primary"
      indeterminate
      ></v-progress-circular>
    </v-card>
    <div v-else>
      <h2>Cykl: {{cycle.name}}</h2>
      <v-layout>

        <v-flex xs3 pa-1>
          <h4>{{$t('cycle.from')}}: {{cycle.from | dateFromDateTime }}</h4>
          <h4>{{$t('cycle.to')}}: {{cycle.to | dateFromDateTime }}</h4>
          <h4>{{$t('cycle.once')}}: {{cycle.lazy | intToYesNo }}</h4>
        </v-flex>
        <v-flex xs3 pa-1>
          <h4>{{$t('cycle.finished')}}: {{cycle.finished | intToYesNo }}</h4>
          <h4>{{$t('cycle.previous')}}: {{cycle.previous}}</h4>
          <h4>{{$t('cycle.created_at')}}: {{cycle.created_at | dateFromDateTime }}</h4>
        </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs4 pa-2>
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFrom"
                :label="`${$t('form.search.from')}`"
                prepend-icon="event"
                readonly
                clearable
                v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker v-model="dateFrom" @input="menuFrom = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateTo"
                :label="`${$t('form.search.to')}`"
                prepend-icon="event"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateTo" @input="menuTo = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <!-- <v-flex xs4 pa-2>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchPhrase"
            append-icon="search"
            :label="`${$t('form.search.search')}`"
            single-line
            hide-details
          ></v-text-field>
        </v-flex> -->
      </v-layout>
      <v-layout>
        <v-flex xs5 pa-2>
          <v-select
            :items="templates"
            item-text="name"
            return-object
            :menu-props="{ maxHeight: '400' }"
            :label="`${$t('form.template')}`"
            v-model="template"
          ></v-select>
        </v-flex>
        <v-flex xs3 pa-2>
          <v-select
            :items="['PDF', 'DOCX']"
            :menu-props="{ maxHeight: '400' }"
            :label="`${$t('form.print-format')}`"
            v-model="format"
          ></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs3 pa-2>
          <v-btn @click="printAllCsv()">
            <v-icon :disabled="!docAvailable" small fab block color="green darken-3" style="color: #efefef">receipt</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="records"
        :loading="updateLoading"
        :rows-per-page-text="tableTranslations.rowsPerPageText"
        :no-data-text="tableTranslations.noDataText"
        :no-results-text="tableTranslations.noResultsText"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :pagination.sync="pagination"
        :total-items="totalAmount"
        class="elevation-1">
        <template slot="headers" slot-scope="props">
         <tr>
           <th
             v-for="header in props.headers"
             :key="header.text"
            class="text-overflow"
             >
            <span class="span-blcok"> {{ header.text }} </span>
           </th>
         </tr>
       </template>
        <template slot="items" slot-scope="props">
          <tr :class="{ 'unconfirmed': !isConfirmed(props.item) }" @dblclick="confirmForm(props.item)">
            <td class="text-overflow" v-for="(header, index) in formHeaders" :key="index">
              <table-view v-if="header.type === fieldType.TABLE"
                :table="formField(header.value)"
                :form_id="props.item.id"
                :rows_amount="props.item[header.value].data"
                @loading="updateLoading = $event" />
              <div v-else-if="header.type === fieldType.PERMAMENT">{{ props.item[header.value] }}</div>
              <div v-else-if="header.type === fieldType.SIGNATURE"> <img class="imageField" :src="'data:image/png;base64,'+props.item[header.value].data" /> </div>
              <div v-else-if="header.type === fieldType.CONFIRMATION">
                <v-tooltip v-if="isConfirmed(props.item)" top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on"><v-icon class="light-green--text">check_circle_outline</v-icon> {{ props.item[header.value].confirmed_by }}</span>
                  </template>
                  <span>{{ props.item[header.value].confirmed_at }}</span>
                </v-tooltip>
                <v-icon v-else @click="confirmForm(props.item)" class="red--text pointer">highlight_off</v-icon>
              </div>
              <div v-else>
                <span v-if="props.item[header.value].validation.pass">{{ props.item[header.value].data }}</span>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on }">
                    <span class="incorrect" v-on="on">{{ props.item[header.value].data | notEmpty }}</span>
                  </template>
                  <span>{{ props.item[header.value].validation.message }}</span>
                </v-tooltip>
              </div>
            </td>
            <td class="text-xs-center">
              <v-btn :disabled="!docAvailable || !isConfirmed(props.item)" small fab block color="blue-grey darken-2" @click="toFile(props.item)">
                <v-icon style="color: #efefef">print</v-icon>
              </v-btn>
            </td>
            <td class="text-xs-center">
              <v-btn
                color="deep-orange darken-3"
                fab small block dark
                @click="deleteForm(props.item.id, props.index)">
                <v-icon dark>delete_forever</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import http from '@/plugins/http'
import fieldType from '@/enums/fieldType'
import TableView from './view/TableView'
import Csv from '@/plugins/printer/Csv'
export default {
  components: { TableView },
  computed: {
    docAvailable() {
      return this.template && this.template.hasOwnProperty('id') !== undefined && this.template.id > 0
    },
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    formHeaders() {
      let y = this.$store.state.forms.headers
      return y
    },
    headers() {
      let headers = this.formHeaders.slice(0)
      headers.push(
          { text: this.$t('form.to-file'), align: 'left', width: '60px', sortable: false },
          { text: this.$t('form.delete.header'), align: 'left', width: '60px', sortable: false })
      return headers
    },
    totalAmount() {
      return this.$store.state.forms.amount
    },
    records() {
     let x=  this.$store.state.forms.records
       return x;
    },
    fieldType() {
      return fieldType
    },
    confirmation() {
      let firstRecord = this.records.find(() => true)
      if(firstRecord) {
        return firstRecord.hasOwnProperty('confirmation')
      }
      return false
    },
    pagination: {
      get: function () {
        return this.$store.state.formPagination
      },
      set: function (value) {
        this.$store.commit('setFormPagination', value)
      }
    },
    itemTrigger() {
      return [ this.pagination, this.dateFrom, this.dateTo ]
    }
  },
  data() {
    return {
      searchPhrase: "",
      dateFrom: "",
      dateTo: "",
      menuFrom: false,
      menuTo: false,
      initialLoading: true,
      updateLoading: false,
      templates: [],
      template: null,
      format: 'PDF',
      cycle:{}
    }
  },
  methods: {
    deleteForm(id, index) {
      this.$confirm(this.$t('form.delete.confirmation'))
      .then(res => {
        if(res) {
          this.updateLoading = true
          this.$store.dispatch('deleteForm', { schema_id: this.$route.params.schemaId, form_id: id, index })
          .then(() => {
            this.updateLoading = false
            this.$store.commit('setSnack', {
              message: this.$t('form.delete.success-message'),
              color: 'success'
            })
          })
          .catch(() => {
            this.updateLoading = false
            this.$store.commit('setSnack', {
              message: this.$t('form.delete.error-message'),
              color: 'danger'
            })
          })
        }
      })
    },
    confirmForm(row) {
      if(!this.isConfirmed(row)) {
        this.$confirm(this.$t('form.confirm.confirmation', { created_by: row.created_by, created_at: row.created_at }))
        .then(res => {
          if(res) {
            this.updateLoading = true
            this.$store.dispatch('confirmForm', { schema_id: this.$route.params.schemaId, form_id: row.id })
            .then(() => {
              this.updateLoading = false
              this.$store.commit('setSnack', {
                message: this.$t('form.confirm.success-message'),
                color: 'success'
              })
            }).catch(() => {
              this.updateLoading = false
              this.$store.commit('setSnack', {
                message: this.$t('form.confirm.error-message'),
                color: 'danger'
              })
            })
          }
        })
      }
    },
    isConfirmed(record) {
      if(this.confirmation) {
        return record.confirmation.hasOwnProperty('confirmed_by') && record.confirmation.confirmed_by !== null
      }
      return true
    },
    toFile(form) {
      http({
        url: '/form/' + form.id + '/print/' + this.template.id + '/' + this.format.toLowerCase(),
        method: 'GET',
        responseType: 'blob'
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.template.name + ' - ' + form.created_at + ', ' + form.created_by + '.' + this.format.toLowerCase());
        document.body.appendChild(link);
        link.click();
      });
    },
    printAllCsv(){
      http.get('cycle/' + this.$route.params.cycleId + '/forms/' + this.$route.params.schemaId+"/1").then(result=>{
        let csv=new Csv(this.$store.state.forms.schema)
        csv.printHeaders().loadFormRecods(result.data).save()
      })
    },
    queryForms() {
        return this.$store.dispatch('loadCycleForms', {
          schema_id: this.$route.params.schemaId,
          cycle_id: this.$route.params.cycleId
        })
      },
      getCycle(id){
        http.get('cycle/' + id).then(response =>{
            this.cycle=response.data
        }).catch(() => {
          this.loading = false
        })
    },
    formField(order) {
      return this.$store.getters.formField(order)
    }
  },
  watch: {
    itemTrigger() {
      if(!this.initialLoading) {
        this.updateLoading = true
        this.queryForms()
        .then(() => {
          this.updateLoading = false
        })
      }
    }
  },
  created() {
    this.$store.commit('setDefaultFormPagination')
    this.initialLoading = true
    Promise.all([
      http.get('templates/' + this.$route.params.schemaId),
      this.queryForms(),
      this.getCycle(this.$route.params.cycleId)
    ]).then(([ templates ]) => {
      this.templates = templates.data
      if(typeof this.templates[0] !== 'undefined') {
        this.template = this.templates[0]
      }
      this.initialLoading = false
    })
  }
}
</script>

<style scoped>
.unconfirmed {
  background: repeating-linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0.1) 10px,
    rgba(0, 0, 0, 0.15) 10px,
    rgba(0, 0, 0, 0.15) 20px
  );
}
.incorrect {
  text-decoration: underline red;
}
.text-overflow{
  text-align: center;
  overflow: scroll;
  width:150px;
  max-width:200px;
/* overflow-wrap: break-word; */
}
.span-blcok{
  display:inline-block;
  height: 50px;
  white-space: normal;
}
.progress-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}
.imageField{
    height:100px;
    /*transform: rotate(-90deg);*/
}
</style>
